const FIELD_STATUSES = ['neutral', 'valid', 'invalid'];

export default class FormField {
    constructor(props = {}) {
        this.props = props;
        this.$root = this.props.$root;
        this.$input = null;

        this.loading = this.props.loading === true;
        this.controller = props.controller;

        this._beforeInit();
        if (!this.loading) {
            this.init();
        }
    }

    get name() {
        return this.controller.name;
    }

    finishLoading() {
        this.init();
    }

    init() {
        this._checkProps();
        this._initElements();
        this._addSubscriptions();
        this._afterInit();
    }

    sync() {
        this._sync();
    }

    reinit($root) {
        this._reinit($root);
    }

    _checkProps() {
        if (!this.$root) {
            throw new Error('FormField: Root element not found!');
        }

        if (!this.controller) {
            throw new Error('FormField: Controller not found!');
        }
    }

    _initElements() {
        this.$input = this.$root.querySelector('[data-form="input"]');

        if (!this.$input) {
            throw new Error('FormField: Input not found!');
        }
    }

    _addSubscriptions() {
        this.controller.subscribe(this.controller.STATE_DROPPED_EVENT, this._refresh.bind(this));
        this.controller.subscribe(this.controller.INITIAL_VALUE_SET_EVENT, this._refresh.bind(this));
    }

    _beforeInit() {}

    _afterInit() {}

    _setStatus(status) {
        if (!FIELD_STATUSES.includes(status)) {
            return;
        }

        this.$root.classList.remove(...FIELD_STATUSES.map((s) => `-${s}`));

        if (status === 'neutral') {
            return;
        }

        this.$root.classList.add(`-${status}`);
    }

    _refresh() {}

    _sync() {}

    _reinit($root) {}
}